<template>
  <v-container>
    <v-card class="pa-0">
      <v-card-title>
        Email Templates
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          v-debounce:300ms="getItems"
          class="pa-0"
        ></v-text-field>
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        dense
        :headers="headers"
        :search="search"
        :items="items.results"
        :server-items-length="items.totalResults"
        :loading="loading"
        :key="items.name"
        :options.sync="pagination"
        :footer-props="{'items-per-page-options':[30, 45, 60, -1]}"
        class="elevation-1"
      >
        <template v-slot:[`item.action`]="{ item }">
        <v-btn
            color="grey darken-2"
            icon
            dark
            :to="'/templates/edit/' + item.id"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import { parseParams,getAlphabets } from "../../plugins/helper";
import { mapMutations } from "vuex";
export default {
  name: "EmailTemplates",
  mounted() {
    this.getItems();
  },
  data() {
    return {
      loading: false,
      templates: {
        name: null
      },
      search: "",
      items: {
        current_page: 1,
        per_page: 10,
        data: [],
      },
      headers: [
        { text: "Subject", value: "subject" },
        { text: "Action", value: "action", sortable: false },
      ],
      pagination: {
        itemsPerPage: 30,
        sortBy: ["id"],
        page: 1,
        filters: {
          item_active: true,
          alphabet: "",
        },
      },
      alphabets: getAlphabets()
    };
  },
  computed: {
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "id";
      return paginationData;
    },
    getStyles() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return {
          maxWidth: "95%",
          margin: "0 auto",
        };
      } else {
        return {};
      }
    },
  },
  watch: {
    pagination: {
      handler: function () {
        this.getItems();
      },
      deep: true,
    }
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    getFormatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    showPreview(item) {
      this.preview_data = item;
      this.show_preview = true;
    },
    getItems() {
      let _self = this;
      this.loading = true;
      let url = parseParams(this.pageData);
      this.$axios
        .get("admin/email_template/list?"+url)
        .then((response) => {
          _self.items = response.data.data;
          this.loading = false;
        })
        .catch(function () {
          this.loading = false;
        });
    }
  
  },
};
</script>